import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { ToolCallPart } from './ChatTypes';

export interface AssistantToolSupport {

    readonly toolName: string;

    readonly ui?: React.NamedExoticComponent<ToolCallPart>;

    readonly command?: CommandDefinition<[any]>;
}

export const AssitantToolSupport = (ats: AssistantToolSupport) => ats;
